var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterMeterTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.9,
    height: 42.1,
    viewBox: "0 0 41.9 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_17",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_372",
    x: 0,
    y: 0.1,
    width: 41.9,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER_METER",
    "data-name": "WATER METER",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_17)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2795",
    d: "M2.92 12.677a15.965 15.965 0 0 1 30.128 0h2.1a17.953 17.953 0 0 0-34.32 0z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2796",
    d: "M33.949 18.685a15.979 15.979 0 0 1-31.931 0h-2a17.978 17.978 0 0 0 35.931 0z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_372)",
    "data-name": "Gruppe 2845",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2792",
    d: "M14.655 28.228a.231.231 0 0 1-.006.027 3.335 3.335 0 1 0 6.669 0v-.027c-.032-1.879-3.332-6.6-3.332-6.6s-3.305 4.72-3.331 6.6m3.959 0a.854.854 0 1 1 1.708 0v.011a.854.854 0 1 1-1.708 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2793",
    d: "M35.968 17.681a17.876 17.876 0 0 0-.53-4H30.8v-1h-2.759a10.494 10.494 0 0 0-20.114 0H5.169v1H.53a17.934 17.934 0 0 0-.53 4h5.169v1H7.93a10.547 10.547 0 0 0 6.554 6.884V24.5a9.5 9.5 0 1 1 7 0v1.064a10.545 10.545 0 0 0 6.554-6.884H30.8v-1h5.169z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2511",
    transform: "translate(9.984 12.677)",
    d: "M0 0h2v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2512",
    transform: "translate(13.484 12.677)",
    d: "M0 0h2v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2513",
    transform: "translate(16.984 12.677)",
    d: "M0 0h2v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2514",
    transform: "translate(20.484 12.677)",
    d: "M0 0h2v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2515",
    transform: "translate(23.984 12.677)",
    d: "M0 0h2v4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2794",
    d: "M12.984 19.553a1.5 1.5 0 1 0 1.5-1.5 1.5 1.5 0 0 0-1.5 1.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMeterTool);
export default __webpack_public_path__ + "static/media/water-meter-tool.2c7c4c269659b88b940615a8f6239783.svg";
export { ForwardRef as ReactComponent };